import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import { setPassiveTouchGestures } from '@polymer/polymer/lib/utils/settings';

import 'jsqr/dist/jsQR.js';

import { defineElement } from '../../utility/defineElement.js';
import { template } from './lag-qrscanner.html.js';

defineElement(class extends PolymerElement {

    static get is() { return 'lag-qrscanner'; }

    static get template() { return template; }

    static get properties () {
        return {
            _code: {
                type: Object
            },
            _takePhotoTimeoutId: {
                type: Number,
                value: 0
            },
            _scanStopped: {
                type: Boolean,
                value: false
            },
            _frequency: {
                type: Number,
                value: 10
            }
        };
    }

    constructor() {
        // If you override the constructor, always call the
        // superconstructor first.
        super();
        // Resolve warning about scroll performance
        // See https://developers.google.com/web/updates/2016/06/passive-event-listeners
        setPassiveTouchGestures(true);
        // this.$.camera.hidden = !this._scanStopped;
    }

    ready(){
        // If you override ready, always call super.ready() first.
        super.ready();
    }

    capture() {
        return new Promise((resolve, reject) => {
            if (
                this.$.camera_view.videoWidth != undefined
                && this.$.camera_view.videoWidth > 0
                && this.$.camera_view.videoHeight != undefined
                && this.$.camera_view.videoHeight > 0
            ) {
                this.$.camera_sensor.width = this.$.camera_view.videoWidth;
                this.$.camera_sensor.height = this.$.camera_sensor.height;

                let ctx = this.$.camera_sensor.getContext("2d");
                ctx.drawImage(this.$.camera_view, 0, 0);

                let imageData = ctx.getImageData(0, 0, this.$.camera_sensor.width * 2, this.$.camera_sensor.height * 2);
                this._code = jsQR(imageData.data, this.$.camera_sensor.width * 2, this.$.camera_sensor.height * 2);

                if (this._code) {
                    this.stopCapture();

                    resolve(this._code.data);
                }
            }
        });
    }

    initCapture() {
        var constraints = { video: { facingMode: "environment" }, audio: false };
        this._scanStopped = false;

        navigator.mediaDevices.getUserMedia(constraints)
            .then((stream) => {
                this.$.camera_view.srcObject = stream;
                this._startCapture();
            })
            .catch((e) => {
                console.error(e);
            })
    }

    _startCapture() {
        if (!this._scanStopped) {
            clearTimeout(this._takePhotoTimeoutId);
            this._takePhotoTimeoutId = 0;
            this._doCapture();
        }
    }

    _doCapture() {
        if (this._takePhotoTimeoutId != undefined && !this._scanStopped) {
            this._previewcamera_sensor();
            clearTimeout(this._takePhotoTimeoutId);
            this._takePhotoTimeoutId = setTimeout(() => {
                this._doCapture();
            }, 34);
        }
        else {
            this._stopCapture();
        }
    }

    _previewcamera_sensor() {
        if (
            this.$.camera_view.videoWidth != undefined
            && this.$.camera_view.videoWidth > 0
            && this.$.camera_view.videoHeight != undefined
            && this.$.camera_view.videoHeight > 0
        ) {
            this.$.camera_sensor.width = this.$.camera_view.videoWidth;
            this.$.camera_sensor.height = this.$.camera_view.videoHeight;

            // this will set the video capture to display on the camera_sensor
            let ctx = this.$.camera_sensor.getContext("2d", { willReadFrequently: true });
            ctx.drawImage(this.$.camera_view, 0, 0);
        }
    }

    stopCapture() {
        clearTimeout(this._takePhotoTimeoutId);
        this._takePhotoTimeoutId = undefined;
        this._scanStopped = true;

        (new Promise((resolve) => {
            let vc = this.$.camera_view;
        }))
    }
});
